<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row" v-if="!isLoading">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12" v-if="verificationError">
                            <div class="alert alert-danger" role="alert">
                                {{ verificationError }}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="changeAccepError">
                        <div class="col-md-12">
                            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                Change token is not valid. You can find the booking from here and accept the changes. Thanks.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <p class="text-center">Bookings details info</p>            
                            <form v-on:submit.prevent="verifyDetails">
                                <div class="mb-3 row">
                                    <label for="booking_ref_no" class="col-sm-2 col-form-label">Booking reference number</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="text" id="booking_ref_no">
                                    </div>
                                </div>
                
                                <div class="mb-3 row">
                                    <label for="surname" class="col-sm-2 col-form-label">Surname of lead passenger</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="text" id="surname">
                                    </div>
                                </div>
                
                                <div class="mb-3 row">
                                    <label for="departure_date" class="col-sm-2 col-form-label">Departure date</label>
                                    <div class="col-sm-10">
                                        <input type="date" class="form-control" id="departure_date">
                                    </div>
                                </div>
                
                                <div class="mb-3 row">
                                    <button class="btn btn-primary">Verify and check booking</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-5" v-else>
                <div class="col-md-12">
                    <div class="loader-container">
                        <div class="dotted-line"></div>
                        <div class="loading-text">Please wait, while we are fetching booking details...</div>
                        <div class="destination-icons">
                            <span>🗽</span>
                            <span>🗼</span>
                            <span>🏰</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'Verify',
    data () {
        return {
            isLoading: false,
            verificationError: null,
            changeAccepError:false
        }
    },
    created () {
        let changeVerification = this.$route.query.changeVerification
        if (changeVerification) {
            this.changeAccepError = true
        }
    },
    methods: {
        verifyDetails(event) {
            let __this = this
            __this.isLoading = true;
            const formElems = event.target.elements
            axios.post(this.$root.$api + 'manage-bookings/verify', {
                booking_ref_no: formElems.booking_ref_no.value,
                surname: formElems.surname.value,
                departure_date: formElems.departure_date.value,
                customer_surname : 'yes'
            })
            .then(res => res.data)
            .then(json => {
                this.$root.loading = false;
                if (typeof(json.success) === 'undefined' || !json.success) {
                    this.$notify({
                        type: 'error',
                        title: json.error
                    });
                    return;
                }
                localStorage.setItem('verify', JSON.stringify(json.data.verify));
                this.$router.push({ name: 'manage-booking' })
                $("html, body").animate({ scrollTop: 0 }, "slow");
            })
                .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    __this.verificationError = error.response.data.error;
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    __this.verificationError = 'No response from server. Please try again later.';
                } else {
                    // Something happened in setting up the request that triggered an Error
                    __this.verificationError = 'An error occurred while setting up the request.';
                }
                __this.isLoading = true;
            })
            .finally(() => {
                __this.isLoading = false;
            })
            
        }
    }
}
</script>